import { createSelector } from 'reselect';

/**
 * Direct selector to the account state domain
 */

const selectFavoritesDomain = state => state.favorites;

const makeSelectSavedBestResources = () =>
  createSelector(
    selectFavoritesDomain,
    substate => substate.savedBestResources,
  );
const makeSelectProcessing = () =>
  createSelector(
    selectFavoritesDomain,
    substate => substate.processing,
  );
const makeSelectFavoritePublicLists = () =>
  createSelector(
    selectFavoritesDomain,
    substate => substate.publicLists,
  );

export {
  makeSelectSavedBestResources,
  makeSelectProcessing,
  makeSelectFavoritePublicLists,
};
